const LOGIN_RETRY_AT_KEY = 'Pulsalink-message-login-retry-at';

export const getLoginRetryAt = () => {
  try {
    const retryAt = Number(localStorage.getItem(LOGIN_RETRY_AT_KEY));
    if (!Number.isFinite(retryAt) || retryAt <= Date.now()) {
      localStorage.removeItem(LOGIN_RETRY_AT_KEY);
      return 0;
    }

    return retryAt;
  } catch {
    return 0;
  }
};

export const getRetryAfterSeconds = (error) => {
  const retryAfter = Number(error?.data?.retryAfter ?? error?.retryAfter);
  if (Number.isFinite(retryAfter) && retryAfter > 0) return Math.ceil(retryAfter);

  const message = [error?.message, error?.data?.error, error?.data?.message]
    .filter(Boolean)
    .join(' ');
  const minutes = message.match(/after\s+(\d+)\s+minutes?/i);
  return minutes ? Number(minutes[1]) * 60 : 15 * 60;
};

export const setLoginRetryAt = (retryAfterSeconds) => {
  const retryAt = Date.now() + Math.max(1, retryAfterSeconds) * 1000;
  try {
    localStorage.setItem(LOGIN_RETRY_AT_KEY, String(retryAt));
  } catch {
    // Keep the in-memory status even when browser storage is unavailable.
  }
  return retryAt;
};

export const clearLoginRetryAt = () => {
  try {
    localStorage.removeItem(LOGIN_RETRY_AT_KEY);
  } catch {
    // Ignore unavailable browser storage.
  }
};
